import { render, staticRenderFns } from "./statsItem.vue?vue&type=template&id=aa7073a2"
import script from "./statsItem.vue?vue&type=script&lang=js"
export * from "./statsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports